export function isServerError(statusCode) {
    const serverErrorCodes = [500, 501, 502, 503, 504]
    return serverErrorCodes.includes(statusCode)
}
